import { Injectable, Injector } from '@angular/core';
import { BullhornNamespace } from 'datasource-service-lib';
import { BullhornComposeMailService, IComposeMailService } from 'email-service-lib';
import { IBowlingAlleyService } from './bowling-alley.service';
import { BullhornBowlingAlleyService } from './bullhorn/bullhorn.bowling-alley.service';

@Injectable({ providedIn: 'root' })
export class ServiceProviderService {
  constructor(private injector: Injector) {}

  getBowlingAlleyService(namespace: string): IBowlingAlleyService | undefined {
    if (namespace === BullhornNamespace.name) {
      return this.injector.get(BullhornBowlingAlleyService);
    }
    return undefined;
  }

  getComposeMailService(namespace: string): IComposeMailService | undefined {
    if (namespace === BullhornNamespace.name) {
      return this.injector.get(BullhornComposeMailService);
    }
    return undefined;
  }
}
